import { RichText } from 'components/Text/RichText';
import { CmsApiRichTextBlockData } from 'modules/cms/api/types/CmsApiRichText';

type Props = {
  data: CmsApiRichTextBlockData;
  fullWidthLayout?: boolean;
  isSidebar?: boolean;
};

export function CmsAmpRichTextBlock({
  data: { html },
  fullWidthLayout,
  isSidebar,
}: Props) {
  return (
    <RichText
      dangerouslySetInnerHTML={{
        __html: html,
      }}
      textAlign={fullWidthLayout && 'center'}
      small={isSidebar}
      requestIsAmp
    />
  );
}
